import { defineComponent as _defineComponent } from 'vue'
import { providerPageExpTrackEvent } from '../experiments/popular-provider-page-exp/helper';

interface Props {
	position?: 'left' | 'right';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TitlePosterRibbonGraphqlLite',
  props: {
    position: { default: 'left' }
  },
  setup(__props: any) {

const props = __props as { position: 'left' | 'right' }



const onRibbonClick = async () => {
	providerPageExpTrackEvent({
		label: 'modal_opened_user_account_watchlist',
		action: 'click',
	});
	const { preventNonSignedInAction } = await import('@/helpers/prevent-non-signed-in-action-helper');
	// since we only display `<TitlePosterRibbonGraphqlLite>` to logged-out users,
	// the next function should always return true and open the `ListsForSignedInUsersModal` modal.
	await preventNonSignedInAction();
};

return { __sfc: true,props, onRibbonClick }
}

})